import React, { useEffect } from "react";
import Grid from "@mui/material/Grid2";
import Button from "@mui/material/Button";
import DownloadIcon from "@mui/icons-material/Download";
import Navigation from "../../Components/Navigation";
import { Card, CardContent, Typography, CardMedia } from "@mui/material";
import Footer from "../../Components/Footer";
import ContactRibbon from "../../Components/ContactRibbon";
import HeroAlt from "../../Components/HeroAlt";
import micanopyMapSQ from "../../Images/Micanopy_map_sq.jpg";
import hawthorneMapSQ from "../../Images/Hawthorne_map_sq.jpg";
import evinstonMapSQ from "../../Images/evinston_map_sq.jpg";
import monteochaMapSQ from "../../Images/monteocha_map_sq.jpg";
import waldoMapSQ from "../../Images/waldo_map_sq.jpg";
import windsorMapSQ from "../../Images/windsor_map_sq.jpg";
import fullMapSQ from "../../Images/full_area_map_sq.jpg";

export default function Maps() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Maps";
  }, []);
  return (
    <main>
      <Navigation />

      <HeroAlt title="View Maps of Eastern Alachua County" />

      <section>
        <Grid
          container
          size={12}
          justifyContent="center"
          padding="2% 0"
          spacing={2}
          backgroundColor="#f4f4f4"
        >
          {/*MEETINGS SECTION */}
          <Grid item size={{ xs: 11, sm: 11, md: 10, lg: 9, xl: 9 }} container>
         
            <Grid size={12} padding="1% 0">
              <p>
                Maps are tools for visualizing communities, sparking
                conversations about local issues, and identifying key community
                assets. Below, you'll find maps highlighting the municipalities
                and unincorporated areas in eastern Alachua County.{" "}
              </p>
            </Grid>
          </Grid>
        </Grid>
      </section>
      <section>
        <Grid
          container
          spacing={4}
          size={12}
          justifyContent="center"
          paddingBottom="4%"
          backgroundColor="#f4f4f4"
        >
          <Grid
            container
            size={{ xs: 12, sm: 12, md: 12, lg: 8, xl: 8 }}
            className="map-icons"
            justifyContent="stretch"
          >
            {/* Evinston Card */}

            <Grid item size={{ xs: 11, sm: 11, md: 6, lg: 3, xl: 3 }}>
              <a
                href={evinstonMapSQ}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <Card>
                  <CardMedia
                    component="img"
                    alt="Card that contains an image of a map of Evinston"
                    height="250"
                    image={evinstonMapSQ}
                  />
                  <CardContent>
                    <Typography className="map-location" variant="h5">
                      Evinston
                    </Typography>

                    <div className="map-buttons">
                      <Button
                        variant="outlined"
                        className="map-button-black"
                        startIcon={<DownloadIcon />}
                        href="https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Maps/evinston_map.pdf"
                        target="_blank"
                      >
                        Regular map
                      </Button>
                      {/*   <Button
                  sx={{ marginTop: 1, textAlign:'center', background:'#020202', color:'white', width:'100%', textDecoration:'underline' }}
                  className='alt-button'
                  startIcon={<DownloadIcon />}
                  href="https://alachuacounty.us/Depts/Sustainability/Documents/Forward%20Focus%20Maps/ff_full_area_map_handout.pdf"
                  target="_blank"
                >
                  Handout map
                </Button> */}
                    </div>
                  </CardContent>
                </Card>
              </a>
            </Grid>

            {/* Full Map Card */}

            <Grid item size={{ xs: 11, sm: 11, md: 6, lg: 3, xl: 3 }}>
              <a
                href={fullMapSQ}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <Card>
                  <CardMedia
                    component="img"
                    alt="Card that contains an image of a Full Area of Alachua County Map"
                    height="250"
                    image={fullMapSQ}
                  />
                  <CardContent>
                    <Typography className="map-location" variant="h5">
                      Full Area Map
                    </Typography>

                    <div className="map-buttons">
                      <Button
                        variant="outlined"
                        className="map-button-black"
                        startIcon={<DownloadIcon />}
                        href="https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Maps/ff_full_area_map.pdf"
                        target="_blank"
                      >
                        Regular map
                      </Button>
                      <Button
                        sx={{
                          marginTop: 1,
                          textAlign: "center",
                          background: "#020202",
                          color: "white",
                          width: "100%",
                          textDecoration: "underline",
                        }}
                        className="alt-button"
                        startIcon={<DownloadIcon />}
                        href="https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Maps/ff_full_area_map_handout.pdf"
                        target="_blank"
                      >
                        Handout map
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              </a>
            </Grid>

            {/* Hawthorne Card */}

            <Grid item size={{ xs: 11, sm: 11, md: 6, lg: 3, xl: 3 }}>
              <a
                href={hawthorneMapSQ}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <Card>
                  <CardMedia
                    component="img"
                    alt="Card that contains an image of a Map of Hawthorne"
                    height="250"
                    image={hawthorneMapSQ}
                  />
                  <CardContent>
                    <Typography className="map-location" variant="h5">
                      Hawthorne
                    </Typography>
                    <div className="map-buttons">
                      <Button
                        variant="outlined"
                        className="map-button-black"
                        startIcon={<DownloadIcon />}
                        href="https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Maps/hawthorne_map_1.pdf"
                        target="_blank"
                      >
                        Regular map
                      </Button>
                      <Button
                        sx={{
                          marginTop: 1,
                          textAlign: "center",
                          background: "#020202",
                          color: "white",
                          width: "100%",
                          textDecoration: "underline",
                        }}
                        className="alt-button"
                        startIcon={<DownloadIcon />}
                        href="https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Maps/hawthorne_map_handout.pdf"
                        target="_blank"
                      >
                        Handout map
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              </a>
            </Grid>

            {/* Micanopy Card */}
            <Grid item size={{ xs: 11, sm: 11, md: 6, lg: 3, xl: 3 }}>
              <a
                href={micanopyMapSQ}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <Card>
                  <CardMedia
                    component="img"
                    alt="Card that contains an image of a Map of Micanopy"
                    height="250"
                    image={micanopyMapSQ}
                  />
                  <CardContent>
                    <Typography className="map-location" variant="h5">
                      Micanopy
                    </Typography>
                    <div className="map-buttons">
                      <Button
                        variant="outlined"
                        className="map-button-black"
                        startIcon={<DownloadIcon />}
                        href="https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Maps/micanopy_map_1.pdf"
                        target="_blank"
                      >
                        Regular map
                      </Button>
                      <Button
                        sx={{
                          marginTop: 1,
                          textAlign: "center",
                          background: "#020202",
                          color: "white",
                          width: "100%",
                          textDecoration: "underline",
                        }}
                        className="alt-button"
                        startIcon={<DownloadIcon />}
                        href="https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Maps/micanopy_map_handout.pdf"
                        target="_blank"
                      >
                        Handout map
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              </a>
            </Grid>

            {/* Monteocha Card */}

            <Grid item size={{ xs: 11, sm: 11, md: 6, lg: 3, xl: 3 }}>
              <a
                href={monteochaMapSQ}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <Card>
                  <CardMedia
                    component="img"
                    alt="Card that contains an image of a map of Evinston"
                    height="250"
                    image={monteochaMapSQ}
                  />
                  <CardContent>
                    <Typography className="map-location" variant="h5">
                      Monteocha
                    </Typography>

                    <div className="map-buttons">
                      <Button
                        variant="outlined"
                        className="map-button-black"
                        startIcon={<DownloadIcon />}
                        href="https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Maps/monteocha_horizontal_map_1.pdf"
                        target="_blank"
                      >
                        Regular map
                      </Button>
                      {/*   <Button
                  sx={{ marginTop: 1, textAlign:'center', background:'#020202', color:'white', width:'100%', textDecoration:'underline' }}
                  className='alt-button'
                  startIcon={<DownloadIcon />}
                  href="https://alachuacounty.us/Depts/Sustainability/Documents/Forward%20Focus%20Maps/ff_full_area_map_handout.pdf"
                  target="_blank"
                >
                  Handout map
                </Button> */}
                    </div>
                  </CardContent>
                </Card>
              </a>
            </Grid>

            {/* Waldo Card */}

            <Grid item size={{ xs: 11, sm: 11, md: 6, lg: 3, xl: 3 }}>
              <a
                href={waldoMapSQ}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <Card>
                  <CardMedia
                    component="img"
                    alt="Card that contains an image of a Map of Waldo"
                    height="250"
                    image={waldoMapSQ}
                  />
                  <CardContent>
                    <Typography className="map-location" variant="h5">
                      Waldo
                    </Typography>
                    <div className="map-buttons">
                      <Button
                        variant="outlined"
                        className="map-button-black"
                        startIcon={<DownloadIcon />}
                        href="https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Maps/waldo_map.pdf"
                        target="_blank"
                      >
                        Regular map
                      </Button>
                      <Button
                        sx={{
                          marginTop: 1,
                          textAlign: "center",
                          background: "#020202",
                          color: "white",
                          width: "100%",
                          textDecoration: "underline",
                        }}
                        className="alt-button"
                        startIcon={<DownloadIcon />}
                        href="https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Maps/waldo_map_handout.pdf"
                        target="_blank"
                      >
                        Handout map
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              </a>
            </Grid>

            {/* Windsor Card */}

            <Grid item size={{ xs: 11, sm: 11, md: 6, lg: 3, xl: 3 }}>
              <a
                href={windsorMapSQ}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <Card>
                  <CardMedia
                    component="img"
                    alt="Card that contains an image of a map of Evinston"
                    height="250"
                    image={windsorMapSQ}
                  />
                  <CardContent>
                    <Typography className="map-location" variant="h5">
                      Windsor
                    </Typography>

                    <div className="map-buttons">
                      <Button
                        variant="outlined"
                        className="map-button-black"
                        startIcon={<DownloadIcon />}
                        href="https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Maps/windsor_map.pdf"
                        target="_blank"
                      >
                        Regular map
                      </Button>
                      {/*   <Button
                  sx={{ marginTop: 1, textAlign:'center', background:'#020202', color:'white', width:'100%', textDecoration:'underline' }}
                  className='alt-button'
                  startIcon={<DownloadIcon />}
                  href="https://alachuacounty.us/Depts/Sustainability/Documents/Forward%20Focus%20Maps/ff_full_area_map_handout.pdf"
                  target="_blank"
                >
                  Handout map
                </Button> */}
                    </div>
                  </CardContent>
                </Card>
              </a>
            </Grid>
          </Grid>
        </Grid>
      </section>

      {/* CODE FOR THE CONTACT US RIBBON */}
      <section className="contact-container">
        <ContactRibbon />
      </section>

      <Footer />
    </main>
  );
}